import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { NAVIGATION_ROUTE } from "../constants";
import useAuth from "../hooks/useAuth";

export default function ProtectedRoutes({ children, allowedRoles }) {
  const { isAuthenticated, user } = useAuth();
  const adminAuth = useSelector(state => state.adminAuth);

  // Check if either user or admin is authenticated
  const isAdminAuthenticated = adminAuth.isAuthenticated;
  const adminRole = adminAuth.admin?.role;

  // If neither is authenticated, redirect
  if (!isAuthenticated && !isAdminAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check allowed roles for user or admin
  const role = user?.role || adminRole;
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={NAVIGATION_ROUTE.unauthorized} replace />;
  }

  return children;
}



